(function($) {

    "use strict";

    $.fn.radioAccordion = function() {
        return $(this).each(function() {
            var element = $(this),
                radios  = $("input[data-target]", element),
                targets = [];

            radios.each(function() {
                var radio = $(this),
                    target = $(radio.data("target"));

                if (target.length) {
                    target.collapse();

                    targets.push(target[0]);
                }

                target.on('hide hidden show shown', function (event) {
                    event.stopPropagation();
                    //radio.attr("checked", event.type === "show" ? "checked" : "");
                });

                if (radio.is(':checked')) {
                    target.collapse('show');
                    target.height('auto');
                } else {
                    target.collapse('hide');
                }

                setTimeout(function() {
                    target.collapse('stopTransitioning');
                }, 300);
            });

            element.on("change", "input[data-target]", function() {
                var radio  = $(this),
                    target = $(radio.data("target"));

                if (radio.is(":checked")) {
                    target.collapse('show');
                    $(targets).not(target).collapse('hide');
                } else {
                    target.collapse('hide');
                }
            });
        });

    };

}(jQuery));
